import type {
  ICubeButtonsController,
  ICubeControlIntegrationApi,
  ICubeController,
  ICubeControllerFactory,
  ICubeSceneController
} from './interfaces';
import { inject, injectable } from 'inversify';
import { TYPES } from './types';
import { CubeController } from './CubeController';

@injectable()
export class CubeControllerFactory implements ICubeControllerFactory {
  private readonly _buttonsController: ICubeButtonsController;

  private readonly _sceneController: ICubeSceneController;

  public constructor(
    @inject(TYPES.ICubeSceneController) sceneController: ICubeSceneController,
    @inject(TYPES.ICubeButtonsController) buttonsController: ICubeButtonsController
  ) {
    this._sceneController = sceneController;
    this._buttonsController = buttonsController;
  }

  public createCubeController(api: ICubeControlIntegrationApi): ICubeController {
    return new CubeController(this._sceneController, this._buttonsController, api);
  }
}
